import screenfull from "screenfull";
import AboutUs from '@/components/aboutUs.vue'
import THEME from '@/components/theme.vue'
import FooterNav from '@/components/footer'
import * as api from './index-api'
import ScreenAdapter from '@/components/screenAdapter.vue'

export default {
    name: "Index",
    components: {
        AboutUs,
        THEME,
        FooterNav,
        ScreenAdapter
    },
    data () {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
            dialogVisible: false,
            menuList: [
            ],
            // pageNo: '',
            appToken: '',
            /* 是否显示侧边栏 */
            showAside: true,
            showMenu: false,
            refresh: true,
            menuBtn: '展开菜单',  //手机端菜单控制按键,

            footerNavData: [
                {
                    name: '首页',
                    icon: 'iconhome',
                    path: '/nav-menu'
                },
                {
                    name: '项目管理',
                    icon: 'iconwork-order',
                    path: '/project'
                },
                {
                    name: '供应商管理',
                    icon: 'iconyonghuguanli',
                    path: '/provider'
                },
                {
                    name: '采购管理',
                    icon: 'iconshenqingbaoxiao',
                    path: '/purchase-list'
                },
            ]
        }
    },
    computed: {
        pageNo: {
            get () {
                return this.$store.state.pageNo
            },
            set (val) {

            }
        }
    },
    async mounted () {
        if (this.isMobileFlag) this.showAside = false
        let appToken = localStorage.getItem('appToken') || ''
        if (appToken) {
            await api.checkToken({ appToken }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.showMenu = true
                } else {
                    this.showMenu = false
                    this.$message.closeAll()
                }
            })
        }
        if (appToken && this.showMenu) {
            this.menuList = [
                {
                    menuName: '项目管理',
                    menuJoint: '/project',
                    menuIcon: 'el-icon-document',
                    menuMuid: '1',
                },
                {
                    menuName: '供应商信息',
                    menuJoint: '/provider',
                    menuIcon: 'el-icon-folder-opened',
                    menuMuid: '2',
                },
                {
                    menuName: '数据分析',
                    menuJoint: '/data-analyze',
                    menuIcon: 'el-icon-pie-chart',
                    menuMuid: '3',
                },
                {
                    menuName: '采购操作',
                    menuJoint: '/add-purchase',
                    menuIcon: 'el-icon-shopping-cart-2',
                    menuMuid: '5',
                },
                {
                    menuName: '采购列表',
                    menuJoint: '/purchase-list',
                    menuIcon: 'el-icon-document',
                    menuMuid: '6',
                },
            ]
            this.pageNo = '1'
        } else {
            this.menuList = [{
                menuName: '上传文件',
                menuJoint: '/up-file',
                menuIcon: '',
                menuMuid: '4',
            }]
            this.pageNo = '1'
        }
    },

    methods: {
        /* api */

        /**********************************  handle */
        async exit () {
            await this.$store.dispatch('delLocal');
            this.$router.push('/login');
        },
        // 全屏事件
        getFullCreeen () {
            if (screenfull.isEnabled) {
                screenfull.toggle();
            }
        },

        // 菜单切换
        change () {
            let menu = document.querySelector('.menu')
            if (this.isCollapse == false) {
                this.width = '60px'
                menu.classList.add('transMenu')
            } else {
                this.width = '200px'
                menu.classList.remove('transMenu')
            }
        },

        // 菜单选择
        select (index, indexPath) {
            console.log(index, indexPath);
            localStorage.setItem('pageNo', index)
            this.pageNo = index
        },

        handleNavmenuClick (path) {
            this.refresh = false
            this.$nextTick(() => {
                this.refresh = true
            })
        },

        //手机端切换显示侧边栏菜单
        isShowMenu () {
            this.showAside = !this.showAside
            console.log(this.menuBtn);
            this.menuBtn = this.menuBtn === '关闭菜单' ? '展开菜单' : '关闭菜单'

            // this.showMenu = !this.showMenu
        },

        // 关于
        aboutUs () {
            this.dialogVisible = true
        },

    }
}
